import React, { Component } from 'react';
import Spinner from '../Spinner';
import { auth } from '../../firebase';

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
  show : false
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event){
    event.preventDefault();
    const { passwordOne , passwordTwo , error} = this.state;

    if(passwordOne === passwordTwo){
      this.setState({
        show : true
      })
      auth.doPasswordUpdate(passwordOne)
      .then(() => { 
        this.setState(()=> ({ ...INITIAL_STATE }));
        alert("Password Updated Successfully !!");
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
      });
    }
    else{
      this.setState({
        error : 'Passwords do not match !! Please make sure both the  passwords are same.'
      })
    }
  }

  render() {
    const {
      passwordOne,
      passwordTwo,
      error,
    } = this.state;


    return (
      <div>
        {this.state.show ?<Spinner />: null}
        <form onSubmit={this.onSubmit} className="login100-form">
          <input
            value={passwordOne}
            onChange={event => this.setState(updateByPropertyName('passwordOne', event.target.value))}
            type="password"
            placeholder="New Password"
            className="wrap-input100" 
            required
            style={{margin : '20px'}}
          />
          <input
            value={passwordTwo}
            onChange={event => this.setState(updateByPropertyName('passwordTwo', event.target.value))}
            type="password"
            placeholder="Confirm New Password"
            className="wrap-input100" 
            required
            style={{margin : '20px'}}
          />

          <button type="submit" className="container-login100" onClick={this.onSubmit} >
            Reset My Password
          </button>

          { error && <p className="error">{error.message ? error.message : error}</p> }
        </form>
      </div>
    );
  }
}

export default PasswordChangeForm;